import { ReactComponent as Logo } from '../../assets/icons/tethering 1.svg'

const Mqtt = () => {
    return <Logo width={20} height={20} fill='white' />
}

export default Mqtt
